import { Routes } from '@angular/router';
import { SalesComponent } from '@manager-app/statistics/sales/sales.component';
import { CitySalesComponent } from '@manager-app/statistics/city-sales/city-sales.component';
import { StoreSalesComponent } from '@manager-app/statistics/store-sales/store-sales.component';
import { ClientSalesComponent } from '@manager-app/statistics/client-sales/client-sales.component';
import { EmployeeSalesComponent } from '@manager-app/statistics/employee-sales/employee-sales.component';
import { ProductCategorySalesComponent } from '@manager-app/statistics/product-category-sales/product-category-sales.component';
import { ProductSalesComponent } from '@manager-app/statistics/product-sales/product-sales.component';
import { ProductsComponent } from '@manager-app/statistics/products/products.component';
import { AbcAnalysisComponent } from '@manager-app/statistics/abc-analysis/abc-analysis.component';
import { RfmAnalysisComponent } from '@manager-app/statistics/rfm-analysis/rfm-analysis.component';
import { RfmAnalysisSegmentComponent } from '@manager-app/statistics/rfm-analysis/segment/rfm-analysis-segment.component';


export const statisticsRouting: Routes = [
  {
    path: 'sales',
    component: SalesComponent
  },
  {
    path: 'city',
    component: CitySalesComponent
  },
  {
    path: 'sales/:type',
    component: SalesComponent
  },
  {
    path: 'store',
    component: StoreSalesComponent
  },
  {
    path: 'client',
    component: ClientSalesComponent
  },
  {
    path: 'employees',
    component: EmployeeSalesComponent
  },
  {
    path: 'product-categories',
    component: ProductCategorySalesComponent
  },
  {
    path: 'products',
    component: ProductsComponent
  },
  {
    path: 'product-sales/:type',
    component: ProductSalesComponent
  },
  {
    path: 'abc-analysis',
    component: AbcAnalysisComponent
  },
  {
    path: 'rfm-analysis',
    component: RfmAnalysisComponent
  },
  {
    path: 'rfm-analysis/segments',
    component: RfmAnalysisSegmentComponent,
    pathMatch: 'full'
  },
];
